import FormattedMessage from 'I18n/components/FormattedMessage';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { useParams } from 'react-router-dom';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { Paths } from '../../constants/paths';
import { useBreadcrumbs } from '../hooks/useBreadcrumbs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function StorefrontBreadcrumbsMessage({
  title,
  pathKey,
  backBreadcrumb
}) {
  if (backBreadcrumb) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceStorefront.breadcrumbs.back"
    });
  }
  switch (pathKey) {
    case 'HOME':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.breadcrumbs.marketplace"
      });
    case 'APPS':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.breadcrumbs.apps"
      });
    case 'AGENTS':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.breadcrumbs.agents"
      });
    case 'SEARCH_RESULTS':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.breadcrumbs.explore"
      });
    case 'FEATURED':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.breadcrumbs.featured"
      });
    case 'LISTING_REVIEWS':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.breadcrumbs.listingReviews"
      });
    case 'FEATURED_COLLECTION':
    case 'LISTING_DETAILS':
      return title || '';
    default:
      return '';
  }
}
export function StorefrontBreadcrumbs({
  title,
  pathKey,
  backBreadcrumb
}) {
  const {
    listingSlug
  } = useParams();
  const items = useBreadcrumbs({
    title,
    pathKey,
    backBreadcrumb,
    listingSlug
  });
  return /*#__PURE__*/_jsx(Breadcrumbs, {
    flush: true,
    marginBlockStart: "0",
    children: items === null || items === void 0 ? void 0 : items.map((item, index) => /*#__PURE__*/_jsxs("span", {
      children: [item.isCurrentPage && /*#__PURE__*/_jsx(StorefrontBreadcrumbsMessage, {
        title: item.title,
        pathKey: item.pathKey,
        backBreadcrumb: backBreadcrumb
      }), item.pathKey && !item.isCurrentPage && /*#__PURE__*/_jsx(UIRouterLink, {
        to: item.listingSlug ? Paths[item.pathKey].replace(':listingSlug', item.listingSlug) : Paths[item.pathKey],
        children: /*#__PURE__*/_jsx(StorefrontBreadcrumbsMessage, {
          title: item.title,
          pathKey: item.pathKey,
          backBreadcrumb: backBreadcrumb
        })
      })]
    }, `${item.pathKey}-${index}`))
  });
}